// External
import { Injectable } from '@angular/core';

//  Internal
import { ConfigService } from '../config/config.service';
import { LinksService } from '../links/links.service';
import { OperatingSystems, ValuesService } from './values.service';

export enum  ParentalAdvisorInstallScenarios {
    NO_PARENTAL = 'no-parental',
    PENDING_INSTALL = 'pending-install'
};

@Injectable({
    providedIn: 'root'
})

export class ParentalValuesService {

    constructor(
        private readonly configService: ConfigService,
        private readonly valuesService: ValuesService,
        private readonly linksService: LinksService,
    ) {}

    parentalAdvisorRestrictionsService = "parentaladvisor/restrictions";

    parentalNewPath = 'parental';

    subsections = {
        [this.valuesService.centralPaths.parental.applications.id]: {
            label: "parental.organiser.tabs.applications",
            path: this.valuesService.centralPaths.parental.applications.path,
            show: true
        },
        [this.valuesService.centralPaths.parental.websites.id]: {
            label: "parental.organiser.tabs.websites",
            path: this.valuesService.centralPaths.parental.websites.path,
            show: true
        },
        [this.valuesService.centralPaths.parental.contacts.id]: {
            label: "parental.organiser.tabs.phonecontacts",
            path: this.valuesService.centralPaths.parental.contacts.path,
            show: true
        },
        [this.valuesService.centralPaths.parental.location.id]: {
            label: "parental.organiser.tabs.childlocation",
            path: this.valuesService.centralPaths.parental.location.path,
            show: true
        },
        [this.valuesService.centralPaths.parental.screentime.id]: {
            label: "parental.organiser.tabs.screentime",
            path: this.valuesService.centralPaths.parental.screentime.path,
            show: true
        }
    };

    parentalTabs: {} = {
        "screentime": {
            id: "screentime",
            label: "parental.organiser.tabs.screentime",
            path: this.valuesService.centralPaths.parental.screentime.path,
            show: true
        },
        "applications": {
            id: "applications",
            label: "parental.organiser.tabs.applications",
            path: this.valuesService.centralPaths.parental.applications.path,
            show: true
        },
        "websites": {
            id: "websites",
            label: "parental.organiser.tabs.websites",
            path: this.valuesService.centralPaths.parental.websites.path,
            show: true
        },
        "childLocation": {
            id: "childLocation",
            label: "parental.organiser.tabs.childlocation",
            path: this.valuesService.centralPaths.parental.location.path,
            show: true
        },
        "phoneContacts": {
            id: "phoneContacts",
            label: "parental.organiser.tabs.phonecontacts",
            path: this.valuesService.centralPaths.parental.contacts.path,
            show: true
        }
    };

    parentalTabsButton: {} = {
        "devices": {
            id: "devices",
            label: "parental.dashboard.nav-menu.tab.option.view_devices",
            path: this.valuesService.centralPaths.parental.devices.path,
        },
        "edit-profile-modal": {
            id: "manage-profile-modal", // edit-profile modal
            label: "parental.dashboard.nav-menu.tab.option.edit_profile",
            path: "",
            modal: {
                name: "manage-profile-modal",
                containerOptions: {type: 'parental-manage-profile'},
                info: true
            },
        },
        "remove_profile_modal": {
            id: "remove-profile-modal", // delete-profile modal
            label: "parental.dashboard.nav-menu.tab.option.delete_profile",
            path: "",
            modal: {
                name: "remove-profile-modal",
                containerOptions: {size: 'sm', buttonDismissable: false},
                info: true
            }
        },
        'settings': {
            id: "settings",
            label: "parental.settings.email_reports.report_settings",
            path:  this.valuesService.centralPaths.parental.path + this.valuesService.centralPaths.parental.settings.path,
        },
        'history': {
            id: "history",
            label: "",
            path: this.valuesService.centralPaths.parental.screentime.path + this.valuesService.centralPaths.parental.screentime.history.path,
        }
    };

    MONDAY   = 0;
    TUESDAY  = 1;
    WENDSDAY = 2;
    THURSDAY = 3;
    FRIDAY   = 4;
    SATURDAY = 5;
    SUNDAY   = 6;
    WEEKENDS = 7;
    WEEKDAYS = 8;
    EVERYDAY = 9;

    cardsOperatingSystems = {
        [this.valuesService.centralPaths.parental.applications.id]: [
            OperatingSystems.WINDOWS,
            OperatingSystems.OSX,
            OperatingSystems.ANDROID
        ],
        [this.valuesService.centralPaths.parental.websites.id]: [
            OperatingSystems.WINDOWS,
            OperatingSystems.OSX,
            OperatingSystems.ANDROID
        ],
        [this.valuesService.centralPaths.parental.contacts.id]: [
            OperatingSystems.IOS,
            OperatingSystems.ANDROID
        ],
        [this.valuesService.centralPaths.parental.location.id]: [
            OperatingSystems.IOS,
            OperatingSystems.ANDROID
        ],
        [this.valuesService.centralPaths.parental.screentime.id]: [
            OperatingSystems.WINDOWS,
            OperatingSystems.OSX,
            OperatingSystems.ANDROID
        ]
    };

    hoursMinutes = [
                    "minute",
                    "minutes",
                    "hour",
                    "hourMinute",
                    "hourMinutes",
                    "hours",
                    "hoursMinute",
                    "hoursMinutes"
                    ];


    daysText = {
        "sunday":   0,
        "moday":    1,
        "tuesday":  2,
        "wendsday": 3,
        "thursday": 4,
        "friday":   5,
        "saturday": 6
    };

    daysTranslate = ["parental.key.mondays", "parental.key.tuesdays", "parental.key.wednesdays", "parental.key.thursdays", "parental.key.fridays",
                    "parental.key.saturdays", "parental.key.sundays"];

    daysOfWeek = [
        "parental.key.sunday",
        "parental.key.monday",
        "parental.key.tuesday",
        "parental.key.wednesday",
        "parental.key.thursday",
        "parental.key.friday",
        "parental.key.saturday"
    ];


    intervalDTLMinutes = 10;
    timeUnitDTL        = 1000;

    DAYS_IN_WEEK = 7;
    HOURS_IN_DAY = 24;
    MIN_IN_HOUR  = 60;
    SEC_IN_HOUR  = 3600;
    SEC_IN_MIN   = 60

    WEEKDAYS_NR = 5;
    WEEKEND_NR  = 2;


    dayWithNoDTL = -1;
    noDTLIndex   = 143;

    nrDevicesShown = 3;

    errorTexts = {
        scheduleName: {
            required: 'parental.screentime.schedule.name.required',
            pattern: 'parental.screentime.schedule.name.special',
            duplicate: 'parental.screentime.schedule.name_duplicate',
            minlength: 'parental.screentime.schedule.minlength',
            maxlength: 'parental.screentime.schedule.maxlength',
        }

    }

    NON_IOT_PLATFORMS = new Set(["windows", "android", "osx", "ios"]);
    NON_AGENT_PLATFORMS = new Set(["android", "ios"])
    SUPPORTED_OS = new Set(["windows", "android", "osx"]);
    NOT_SUPPORTED_OS = new Set(["ios"]);
    MOBILE_PLATFORMS = new Set(["ios", "android"]);
    DESKTOP_PLATFORMS = new Set(["windows", "osx"]);

    IOT_TYPE = "IoT";
    IOS_TYPE = "iOS";

    installEventsNames = new Set(["push:new_device", "push:device_info_changed", "push:applications_list_changed"]);

    events = {
        deviceAddedParental: "deviceAddedParental"
    };

    appStatus = {
        installed: 2,
        pending: 1,
        notInstalled: 0,
        unsupported: -1
    };

    websiteAction = {
        block: "block",
        remove: "remove",
        allow: "allow"
    };

    messagesTodayCard = {
        "today_screentime_usage_not_available": 0,
        "today_screentime_usage_recommended": 1,
        "today_screentime_usage_recommended_exceeded": 2,
        "today_screentime_usage_recommended_exceeded_with_late_hours": 3,
        "today_screentime_usage_recommended_with_late_hours": 4,
        "today_screentime_usage_limits": 5,
        "today_screentime_usage_limits_with_late_hours": 6
    }

    messagesDailyCard = {
        "screentime_usage_recommended": 0,
        "screentime_usage_recommended_exceeded": 1,
        "screentime_usage_recommended_with_some_exceeded": 2,
        "screentime_usage_recommended_with_late_hours": 3,
        "screentime_usage_recommended_exceeded_with_late_hours": 4,
        "screentime_usage_recommended_with_some_exceeded_late_hours": 5,
        "screentime_usage_limits_with_late_hours": 6,
        "screentime_usage_limits_and_schedule": 7,
        "screentime_usage_limits_and_schedule_with_late_hours": 8
    };

    linksWhatCanYouDo = {
        1: 'https://www.bitdefender.com/box/blog/family/want-reduce-screen-time-house-can/',
        2: 'https://www.bitdefender.com/box/blog/family/protect-children-online-depending-age/',
        5: 'https://www.bitdefender.com/box/blog/family/digital-wellness-families-5-practical-tips-tricks/',
        6: 'https://www.bitdefender.com/box/blog/family/rcpch-guide-4-questions-help-parents-manage-screen-time-within-family/'
    };

    buyAllLink = this.linksService.getOffersLink();

    /*
     * mapare intre message_id,link_id,text_id
     * message_id = messageLinkTextMap[i]
     * text_id = messageLinkTextMap[i][1]
     * link_id = messageLinkTextMap[i][2]
     * undefined - nu afisam modala
     */
    messageLinkTextMap = [undefined, [1, 1], [2, 2], [3, 1], [4, 1], [4, 5], [3, 6], undefined, [3, 6]];

    lateHoursInterval = {start: '12:00', end: '6:00'};

    noLimitValue = 86400000; // no limit

    enLanguages = ['en_US', 'en_GB', 'en_AU'];

    supportPCArtLink = 'https://www.bitdefender.com/consumer/support/answer/15233/';

    maxSecondsCounter = 60;

    pinMapLocationCard: string = this.configService.config.pathImages + 'pin.svg';

    daysDTL = [
        'activity.monday',
        'activity.tuesday',
        'activity.wednesday',
        'activity.thursday',
        'activity.friday',
        'activity.saturday',
        'activity.sunday',
        'parental.screentime.dtl.weekends',
        'parental.screentime.dtl.weekdays',
        'parental.screentime.dtl.everyday'
    ];

    chartColors = {
        primary: 'rgb(94, 58, 154)',
        mutedPrimary: 'rgb(223, 216, 235)',
        gray: 'rgb(158, 159, 164)',
        mutedGray: 'rgb(217, 217, 217)',
        secondary: 'rgba(7, 20, 45, 1)',
        mutedSecondary: 'rgba(7, 20, 45, 0.4)',
        red: '#cb0217'
    };

    extensionsFile = ['jpeg', 'png', 'jpg', 'gif'];
    maxSizeFile = 2000000;

    genderTypes: any = [
        {name: 'devices.edit.profile.modal.gender.not.specified', type: 'u'},
        {name: 'devices.edit.profile.modal.gender.male', type: 'm'},
        {name: 'devices.edit.profile.modal.gender.female', type: 'f'}
    ];

    errorsFormCreateChild = {
        childName: {
            required: 'install.modal.child.name.error.required',
            pattern: 'install.modal.child.name.error.pattern',
            minlength: 'install.modal.child.name.error.minlength',
            maxlength: 'install.modal.child.name.error.maxlength',
            duplicate: 'install.modal.child.name.error.duplicate'
        },
        dateOfChildBirth: {
            required: 'install.modal.child.birth.error.required'
        },
        picture: {
            filesStatus: 0,
            error: '',
            extension: 'devices.profile.picture.error.type',
            size: 'devices.profile.picture.error.size',
            upload: 'devices.profile.picture.error.upload'
        }
    };

    ageCategoryName = {
        toddler: 'toddler',
        kid: 'kid',
        teen: 'teen'
    };

    installScenarios = {
        noParental: "parental-1",
        pendingInstall: "parental-3"
    };

    placeholders = {
        appName: '{{parentalProductName}}',
        childName: '{{childName}}'
    };

    reportSettingsFrequency = [
        {label: 'parental.report-settings.option.daily', value: 0},
        {label: 'parental.report-settings.option.weekly', value: 1}
    ];

    selectOptionValue = 2;

    chartLabels = {
        availableScreentime: 'available-screentime'
    };

    chartsStyle = {
        today: {
            datasets: {
                screentime: {
                    label: 'screentime',
                    xAxisID: "screentime",
                },
                available: {
                    label: this.chartLabels.availableScreentime,
                    xAxisID: this.chartLabels.availableScreentime,
                    backgroundColor: this.chartColors.mutedPrimary
                },
                schedule: {
                    label: 'schedule',
                    xAxisID: "schedule",
                    backgroundColor: this.chartColors.mutedGray
                },
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                hover: false,
            },
            tooltips: {
                mode: 'nearest',
                position: 'nearest',
                yAlign: 'bottom',
                displayColors: false,
            },
            layout: {
                padding: {
                    top: 30,
                    left: 0
                }
            },
            legend: {
                display: false
            },
            scales_y: [{
                stacked: false,
                gridLines: {
                    display: false,
                    tickMarkLength: 0
                },
                ticks: {
                    beginAtZero : true,
                    display: false
                }
            }],
            scales_x: {
                style: {
                    display: true,
                    stacked: true,
                    id: "screentime",
                    offset: true,
                    gridLines: {
                        display: false,
                        tickMarkLength: 10
                    },
                },
                ticks: {
                    fontSize: 10,
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                    display: true,
                },
                screentime: {
                    display: false,
                    stacked: true,
                    id: this.chartLabels.availableScreentime,
                    offset: true
                },
                schedule: {
                    display: false,
                    stacked: true,
                    id: "schedule",
                    offset: true
                }
            }
        },
        moreDays: {
            datasets: {
                base: {
                    label: 'base',
                    xAxisID: "bar-base",
                    backgroundColor: 'transparent',
                    barPercentage: 0.66,
                    categoryPercentage: 1,
                },
                screentime: {
                    label: 'screentime',
                    xAxisID: "bar-screentime",
                    backgroundColor: this.chartColors.primary,
                    barPercentage: 0.66,
                    categoryPercentage: 1,
                    borderWidth: { top: 0, right: 0, left: 0, bottom: 2}
                },
                empty: {
                    label: 'empty-screentime',
                    xAxisID: "bar-empty-screentime",
                    backgroundColor: 'transparent',
                    barPercentage: 0.66,
                    categoryPercentage: 1,
                    barThickness: 'flex',
                    borderWidth: 1,
                    borderSkipped: 'chartArea',
                    borderColor: this.chartColors.primary
                },
            },
            type_bar: {
                type: 'bar',
                responsive: true,
                maintainAspectRatio: false,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                hover: false,
            },
            layout: {
                padding: {
                    top: 40,
                    bottom: 50
                }
            },
            layout_thirty: {
                padding: {
                    top: 30,
                    bottom: 50
                }
            },
            legend: {
                style: {
                    display: false,
                    position: 'bottom',
                    align: 'start',
                    fontSize: 12,
                },
                label: {
                    useLineStyle: true,
                    boxWidth: 15,
                    position: 'left',
                }
            },
            tooltips: {
                mode: 'nearest',
                position: 'nearest',
                intersect: true,
                yAlign: 'bottom',
                displayColors: false,
            },
            scales_y: [{
                stacked: false,
                gridLines: {
                    display: true,
                    color: 'transparent',
                    zeroLineColor: this.chartColors.primary,
                    zeroLineWidth: 1
                },
                ticks: {
                    beginAtZero : true,
                    display: false
                }
            }],
            scales_x: {
                style: {
                    id: "bar-screentime",
                    stacked: true,
                    gridLines: {
                        display: false,
                    },
                },
                ticks: {
                    beginAtZero : true,
                    display: true,
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                },
                ticks_font: {
                    fontSize: 9,
                },
                ticks_font_thirty: {
                    fontSize: 4,
                },
                bar_empty: {
                    display: false,
                    stacked: true,
                    id: "bar-empty-screentime",
                    offset: true
                },
                bar_base: {
                    display: false,
                    stacked: true,
                    id: "bar-base",
                    offset: true,
                    max: 60
                }
            }
        }
    };

    colorsAreaLocation = {
        'restricted': 'rgba(217, 0, 22)',
        'safe': 'rgba(22, 137, 22)',
        'none': '#00FFFF00'
    };

    storage = {
        areaInfo: 'areaInfo'
    };

    icons = {
        'ios': 'connect_icon_apple card_deviceicon',
        'osx': 'connect_icon_apple card_deviceicon',
        'android': 'connect_icon_android card_deviceicon',
        'windows': 'connect_icon_windows card_deviceicon',
        'unknown': 'connect_icon_question card_deviceicon',
        'linux': 'connect_icon_question card_deviceicon'
    };

    deviceMessageLocation = {
        'parental.dashboard.location.card.label.not_supported': 'parental.location.devices.message.not-supported',
        'parental.dashboard.location.card.label.need_attention': 'parental.location.devices.message.pending',
    };

    omniture = {
        eventClick: {
            updateEmail: 'parentalSettingsUpdateEmail',
            tapOnUnause: 'TapOnUnause',
            tapOnPause: 'TapOnPause',
            tapOnShowInfoContacts: 'TapOnShowInfoContacts',
            tapOnShowInfoLocation: 'TapOnShowInfoLocation'
        },
        sections: {
            dashboard: {
                today: 'today',
                week: '7days'
            },
            location: {
                editArea: 'editArea',
                addArea: 'addArea',
                locateArea: 'locateArea',
                locateDevice: 'locateDevice',
                openRemoveArea: 'openRemoveArea',
            }
        },
        otherDevice: 'other-device',
        sendEmail: 'send-email',
        pendingInstallation: 'pending-installation',
        editchild: 'editchild',
        createchild: 'createchild',
        childcreated: 'childcreated'
    };

    upgradeParentalStartDate = '2024-05-09';
    invalidEmailErrCode = 32600;
}
